<template>
	<div>
		<v-progress-linear
			indeterminate
			class="my-2"
			color="rgba(0, 0, 0, 0.12)"
			height="12"
		></v-progress-linear>
		<v-progress-linear
			indeterminate
			class="my-2"
			color="rgba(0, 0, 0, 0.12)"
			height="12"
		></v-progress-linear>
	</div>
</template>
<script>
export default {
	name: 'ProgressDoubleLinear',
}
</script>